import { render, staticRenderFns } from "./YinDao.vue?vue&type=template&id=1f4d55d2&scoped=true&"
import script from "./YinDao.vue?vue&type=script&lang=js&"
export * from "./YinDao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d55d2",
  null
  
)

export default component.exports